import { Dispatch } from 'redux';
import { getNewbuildingRecommendationsApi } from '../../../../app/api/get_newbuilding_recommendations';
import { IMainPage, IMainPageAction } from '../../../types/mainpage';
import { IMakeRequest } from '../../../utils/network_helper';
import { INewbuildingRecommendations } from '../../../types/newbuilding_recommendations';
import { TThunkAction } from '../../../types/redux';

export const GET_SUCCESS = 'mainpage/GET_SUCCESS';
export const GET_NEWBUILDING_RECOMMENDATIONS = 'mainpage/GET_NEWBUILDING_RECOMMENDATIONS';

export const EXPERIMENTS_GET_SUCCESS = 'mainpage/EXPERIMENTS_GET_SUCCESS';

/* istanbul ignore next */
export const experimentsSuccess = (data: { experiments: {} }): IMainPageAction => {
  return {
    experiments: data.experiments,
    type: EXPERIMENTS_GET_SUCCESS,
  };
};

/* istanbul ignore next */
export const mainpageSuccess = (response: { data: IMainPage }): IMainPageAction => {
  return {
    mainpage: response.data,
    type: GET_SUCCESS,
  };
};

/* istanbul ignore next */
export const getNewbuildingRecommendations = (recommendations: INewbuildingRecommendations[]): IMainPageAction => {
  return {
    type: GET_NEWBUILDING_RECOMMENDATIONS,
    newbuilding_recommendations: recommendations,
  };
};

export const getExperimentsFlags = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dispatch: Dispatch<any>,
  makeRequest: IMakeRequest,
  activeExperiments: string[],
  queryString?: string,
) => {
  const apiBaseUrl = '/cian-api/site/v1/get-ab-experiments/';

  const experimentsParams = activeExperiments.reduce(
    (acc, experimentName, index, arr) => acc + `experiments=${experimentName}${index < arr.length - 1 ? '&' : ''}`,
    '',
  );

  return makeRequest({
    method: 'GET',
    uri: {
      path: `${apiBaseUrl}?${experimentsParams}${experimentsParams && queryString ? '&' + queryString : ''}`,
    },
    withCredentials: true,
  })
    .then((res: { data: { experiments: {} } }) => {
      dispatch(experimentsSuccess(res.data));
    })
    .catch((err: Error) => {
      throw err;
    });
};

export const ACTIVE_EXPERIMENTS = [
  'mainpage_newbuilding_search',
  'audience_mainpage_filters_price',
  'audience_mainpage_filters',
  'newbuilding_recommendations',
  'main_page_property_guides',
];

/* istanbul ignore next */
export const getNewbuildingRecommendationsData = (): TThunkAction => {
  return (dispatch: Dispatch<any>, getState, context) => {
    const {
      mainpage: {
        regionsData: { subdomainRegionId, subdomainCityId },
      },
    } = getState();
    const regionDraw = subdomainRegionId || subdomainCityId;

    return getNewbuildingRecommendationsApi(context.makeRequest, regionDraw).then(data => {
      dispatch(getNewbuildingRecommendations(data));
    });
  };
};
